/*	
 *	jQuery mmenu 3.0.2
 *
 *	Copyright (c) 2013 Fred Heusschen
 *	www.frebsite.nl
 *
 *	Dual licensed under the MIT and GPL licenses.
 *	http://en.wikipedia.org/wiki/MIT_License
 *	http://en.wikipedia.org/wiki/GNU_General_Public_License
 */


!function (a) {
    function n(b) {
        if ("string" == typeof b) switch (b) {
            case"top":
            case"right":
            case"bottom":
            case"left":
                b = {position: b}
        }
        if ("object" != typeof b && (b = {}), "undefined" != typeof b.addCounters && (a.fn.mmenu.deprecated("addCounters-option", "counters.add-option"), b.counters = {add: b.addCounters}), "undefined" != typeof b.closeOnClick && (a.fn.mmenu.deprecated("closeOnClick-option", "onClick.close-option"), b.onClick = {close: b.closeOnClick}), "undefined" != typeof b.onClick && ("undefined" != typeof b.onClick.delayPageload && (a.fn.mmenu.deprecated("onClick.delayPageload-option", "onClick.delayLocationHref-option"), b.onClick.delayLocationHref = b.onClick.delayPageload), "number" == typeof b.onClick.delayLocationHref && (a.fn.mmenu.deprecated("a number for the onClick.delayLocationHref-option", "true/false"), b.onClick.delayLocationHref = b.onClick.delayLocationHref > 0 ? !0 : !1)), "undefined" != typeof b.configuration && "undefined" != typeof b.configuration.slideDuration && (a.fn.mmenu.deprecated("configuration.slideDuration-option", "configuration.transitionDuration-option"), b.configuration.transitionDuration = b.configuration.slideDuration), "boolean" == typeof b.onClick ? b.onClick = {close: b.onClick} : "object" != typeof b.onClick && (b.onClick = {}), b = a.extend(!0, {}, a.fn.mmenu.defaults, b), "string" != typeof b.configuration.pageSelector && (b.configuration.pageSelector = "> " + b.configuration.pageNodetype), a.fn.mmenu.useOverflowScrollingFallback()) switch (b.position) {
            case"top":
            case"bottom":
                a.fn.mmenu.debug('position: "' + b.position + '" not possible when using the overflowScrolling-fallback.'), b.position = "left"
        }
        return b
    }

    function o() {
        b = a(window), c = a("html"), d = a("body"), g = a(), i = {
            page: H("page"),
            blocker: H("blocker"),
            blocking: H("blocking"),
            opened: H("opened"),
            opening: H("opening"),
            submenu: H("submenu"),
            subopen: H("subopen"),
            fullsubopen: H("fullsubopen"),
            subclose: H("subclose"),
            subopened: H("subopened"),
            subopening: H("subopening"),
            subtitle: H("subtitle"),
            selected: H("selected"),
            label: H("label"),
            noresult: H("noresult"),
            noresults: H("noresults"),
            nosubresult: H("nosubresult"),
            search: H("search"),
            counter: H("counter"),
            accelerated: H("accelerated"),
            dragging: H("dragging"),
            nooverflowscrolling: H("no-overflowscrolling")
        }, j = {
            toggle: I("toggle"),
            open: I("open"),
            close: I("close"),
            search: I("search"),
            reset: I("reset"),
            keyup: I("keyup"),
            keydown: I("keydown"),
            count: I("count"),
            resize: I("resize"),
            opening: I("opening"),
            opened: I("opened"),
            closing: I("closing"),
            closed: I("closed"),
            setPage: I("setPage"),
            setSelected: I("setSelected"),
            transitionend: I("transitionend"),
            touchstart: I("touchstart"),
            mousedown: I("mousedown"),
            click: I("click"),
            dragleft: I("dragleft"),
            dragright: I("dragright"),
            dragup: I("dragup"),
            dragdown: I("dragdown"),
            dragend: I("dragend")
        }, k = {
            opened: J("opened"),
            options: J("options"),
            parent: J("parent"),
            sub: J("sub"),
            style: J("style"),
            scrollTop: J("scrollTop"),
            offetLeft: J("offetLeft")
        }, a.fn.mmenu.useOverflowScrollingFallback(m)
    }

    function p(b, c) {
        return b || (b = a(c.pageSelector, d), b.length > 1 && (b = b.wrapAll("<" + c.pageNodetype + " />").parent())), b.addClass(i.page), b
    }

    function q(b, c, d) {
        return b.contents().each(function () {
            3 == a(this)[0].nodeType && a(this).remove()
        }), b.is(d.menuNodetype) || (b = a("<" + d.menuNodetype + " />").append(b)), d.clone && (b = b.clone(!0), b.add(b.find("*")).filter("[id]").each(function () {
            a(this).attr("id", H(a(this).attr("id")))
        })), b.prependTo("body").addClass(H("menu")).addClass(H(c)), a("li." + d.selectedClass, b).removeClass(d.selectedClass).addClass(i.selected), a("li." + d.labelClass, b).removeClass(d.labelClass).addClass(i.label), b
    }

    function r(b, c, d) {
        b.addClass(H(c)), a("ul ul", b).addClass(i.submenu).each(function (b) {
            var e = a(this), f = e.parent(), g = f.find("> a,> span"), h = f.parent(),
                j = e.attr("id") || H("s" + d + "-" + b);
            e.data(k.parent, f), f.data(k.sub, e), e.attr("id", j);
            var l = a('<a class="' + i.subopen + '" href="#' + j + '" />').insertBefore(g);
            if (g.is("a") || l.addClass(i.fullsubopen), "horizontal" == c) {
                var j = h.attr("id") || H("p" + d + "-" + b);
                h.attr("id", j), e.prepend('<li class="' + i.subtitle + '"><a class="' + i.subclose + '" href="#' + j + '">' + g.text() + "</a></li>")
            }
        }), "horizontal" == c ? (a("li." + i.selected, b).parents("li." + i.selected).removeClass(i.selected).end().each(function () {
            var b = a(this), c = b.find("> ul");
            c.length && (b.parent().addClass(i.subopened).addClass(i.subopening), c.addClass(i.opened))
        }).parent().addClass(i.opened).parents("ul").addClass(i.subopened).addClass(i.subopening), a("ul." + i.opened, b).length || a("ul", b).not("." + i.submenu).addClass(i.opened), a("ul ul", b).appendTo(b)) : a("li." + i.selected, b).addClass(i.opened).parents("." + i.selected).removeClass(i.selected)
    }

    function s(b, c) {
        return b || (b = a('<div id="' + i.blocker + '" />').appendTo(d)), G(b, function () {
            c.trigger(j.close)
        }, !0, !0), b
    }

    function t(b, d, f, g) {
        var h = a("li", b).off(j.setSelected).on(j.setSelected, function () {
            h.removeClass(i.selected), a(this).addClass(i.selected)
        }), l = a("a", b).not("." + i.subopen).not("." + i.subclose);
        G(l, function () {
            var g = a(this), h = g.attr("href");
            F(d.setSelected, g) && g.parent().trigger(j.setSelected), F(d.blockUI, g, "#" != h.slice(0, 1)) && c.addClass(i.blocking);
            var k = "function" == typeof d.callback, l = function () {
                d.callback.call(g[0])
            };
            close = F(d.close, g), delayLocationHref = F(d.delayLocationHref, g), setLocationHref = F(d.setLocationHref, g, "#" != h), setLocationHrefFn = function () {
                window.location.href = h
            };
            var m = !1;
            close && (setLocationHref && (delayLocationHref ? D(e, setLocationHrefFn, f.transitionDuration) : setLocationHrefFn()), k && D(e, l, f.transitionDuration), m = b.triggerHandler(j.close)), close && m || (setLocationHref && setLocationHrefFn(), k && l())
        }), g ? (G(a("a." + i.subopen, b), function () {
            var b = a(this).parent().data(k.sub);
            b && b.trigger(j.open)
        }), G(a("a." + i.subclose, b), function () {
            a(this).parent().parent().trigger(j.close)
        })) : G(a("a." + i.subopen, b), function () {
            var b = a(this).parent().data(k.sub);
            b && b.trigger(j.toggle)
        })
    }

    function u(b, c) {
        var d = b.attr("id");
        d && d.length && G(a('a[href="#' + d + '"]', c), function () {
            b.trigger(j.toggle)
        });
        var d = c.attr("id");
        d && d.length && G(a('a[href="#' + d + '"]', c), function () {
            b.trigger(j.close)
        })
    }

    function v(a, b, c) {
        return w(a, b, c), setTimeout(function () {
            x(a, b, c)
        }, 10), "open"
    }

    function w(a, d, f) {
        var h = C();
        g.not(a).trigger(j.close), e.data(k.style, e.attr("style") || "").data(k.scrollTop, h).data(k.offetLeft, e.offset().left);
        var l = 0;
        b.off(j.resize).on(j.resize, function () {
            var c = b.width();
            c != l && (l = c, e.width(c - e.data(k.offetLeft)))
        }).trigger(j.resize), f.preventTabbing && b.off(j.keydown).on(j.keydown, function (a) {
            return 9 == a.keyCode ? (a.preventDefault(), !1) : void 0
        }), a.addClass(i.opened), f.hardwareAcceleration && c.addClass(i.accelerated), c.addClass(i.opened).addClass(H(d.position)), e.scrollTop(h)
    }

    function x(a, b, d) {
        D(e, function () {
            a.trigger(j.opened)
        }, d.transitionDuration), c.addClass(i.opening), a.trigger(j.opening)
    }

    function y(a, d, f) {
        return D(e, function () {
            a.removeClass(i.opened), c.removeClass(i.opened).removeClass(H(d.position)).removeClass(i.accelerated), e.attr("style", e.data(k.style)), b.off(j.resize), h && h.scrollTop(e.data(k.scrollTop)), a.trigger(j.closed)
        }, f.transitionDuration), c.removeClass(i.opening), b.off(j.keydown), a.trigger(j.closing), "close"
    }

    function z(a) {
        if (a.hasClass(i.opened)) return !1;
        d.scrollTop(0), c.scrollTop(0), a.removeClass(i.subopening).addClass(i.opened);
        var e = a.data(k.parent);
        return e && e.parent().addClass(i.subopening), "open"
    }

    function A(a, b, c, d) {
        if (!a.hasClass(i.opened)) return !1;
        var e = a.data(k.parent);
        return e && (D(b, function () {
            a.removeClass(i.opened)
        }, d.transitionDuration), e.parent().removeClass(i.subopening)), "close"
    }

    function B(a) {
        switch (a) {
            case 9:
            case 16:
            case 17:
            case 18:
            case 37:
            case 38:
            case 39:
            case 40:
                return !0
        }
        return !1
    }

    function C() {
        return h || (0 != c.scrollTop() ? h = c : 0 != d.scrollTop() && (h = d)), h ? h.scrollTop() : 0
    }

    function D(b, c, d) {
        a.fn.mmenu.support.transition ? b.one(j.transitionend, c) : setTimeout(c, d)
    }

    function E(a, b, c) {
        return b > a && (a = b), a > c && (a = c), a
    }

    function F(a, b, c) {
        return "function" == typeof a ? a.call(b) : "undefined" == typeof a && "undefined" != typeof c ? c : a
    }

    function G(b, c, d, e) {
        "string" == typeof b && (b = a(b));
        var f = d ? a.fn.mmenu.support.touch ? j.touchstart : j.mousedown : j.click;
        e || b.off(f), b.on(f, function (a) {
            a.preventDefault(), a.stopPropagation(), c.call(this, a)
        })
    }

    function H(a) {
        return "mm-" + a
    }

    function I(a) {
        return a + ".mm"
    }

    function J(a) {
        return "mm-" + a
    }

    var i, j, k, b = null, c = null, d = null, e = null, f = null, g = null, h = null;
    a.fn.mmenu = function (c) {
        return b || o(), c = n(c), this.each(function () {
            var b = a(this), d = c.slidingSubmenus ? "horizontal" : "vertical";
            g = g.add(b), b.data(k.options, c).data(k.opened, !1), l++, e = p(e, c.configuration), b = q(b, c.position, c.configuration), f = s(f, b, c.configuration), r(b, d, l), t(b, c.onClick, c.configuration, c.slidingSubmenus), u(b, e), a.fn.mmenu.counters(b, c.counters, c.configuration), a.fn.mmenu.search(b, c.searchfield, c.configuration), a.fn.mmenu.dragOpen(b, c.dragOpen, c.configuration);
            var h = b.find("ul");
            b.add(h).off(j.toggle + " " + j.open + " " + j.close).on(j.toggle + " " + j.open + " " + j.close, function (a) {
                a.preventDefault(), a.stopPropagation()
            }), b.on(j.toggle, function () {
                return b.triggerHandler(b.data(k.opened) ? j.close : j.open)
            }).on(j.open, function (a) {
                return b.data(k.opened) ? (a.stopImmediatePropagation(), !1) : (b.data(k.opened, !0), v(b, c, c.configuration))
            }).on(j.close, function (a) {
                return b.data(k.opened) ? (b.data(k.opened, !1), y(b, c, c.configuration)) : (a.stopImmediatePropagation(), !1)
            }).off(j.setPage).on(j.setPage, function (a, d) {
                e = p(d, c.configuration), u(b, e)
            }), "horizontal" == d ? h.on(j.toggle, function () {
                return a(this).triggerHandler(j.open)
            }).on(j.open, function () {
                return z(a(this), c)
            }).on(j.close, function () {
                return A(a(this), b, c, c.configuration)
            }) : h.on(j.toggle, function () {
                var c = a(this);
                return c.triggerHandler(c.parent().hasClass(i.opened) ? j.close : j.open)
            }).on(j.open, function () {
                return a(this).parent().addClass(i.opened), "open"
            }).on(j.close, function () {
                return a(this).parent().removeClass(i.opened), "close"
            })
        })
    }, a.fn.mmenu.defaults = {
        position: "left",
        slidingSubmenus: !0,
        onClick: {close: !0, setSelected: !0, delayLocationHref: !0},
        configuration: {
            preventTabbing: !0,
            hardwareAcceleration: !0,
            selectedClass: "Selected",
            labelClass: "Label",
            counterClass: "Counter",
            pageNodetype: "div",
            menuNodetype: "nav",
            transitionDuration: 400,
            dragOpen: {pageMaxDistance: 250, pageMinVisible: 0}
        }
    }, a.fn.mmenu.search = function (b, c) {
        if ("boolean" == typeof c ? c = {add: c, search: c} : "string" == typeof search && (c = {
            add: !0,
            search: !0,
            placeholder: c
        }), "object" != typeof c && (c = {}), c = a.extend(!0, {}, a.fn.mmenu.search.defaults, c), c.add) {
            var d = a('<div class="' + i.search + '" />').prependTo(b);
            d.append('<input placeholder="' + c.placeholder + '" type="text" autocomplete="off" />'), c.noResults && a("ul", b).not("." + i.submenu).append('<li class="' + i.noresults + '">' + c.noResults + "</li>")
        }
        if (c.search) {
            var d = a("div." + i.search, b), e = a("input", d), f = a("li." + i.label, b), g = a("em." + i.counter, b),
                h = a("li", b).not("." + i.subtitle).not("." + i.label).not("." + i.noresults), l = "> a";
            c.showLinksOnly || (l += ",> span"), e.off(j.keyup).on(j.keyup, function (a) {
                B(a.keyCode) || e.trigger(j.search)
            }), b.off(j.reset + " " + j.search).on(j.reset + " " + j.search, function (a) {
                a.preventDefault(), a.stopPropagation()
            }).on(j.reset, function () {
                e.val(""), b.trigger(j.search)
            }).on(j.search, function (c, d) {
                "string" == typeof d ? e.val(d) : d = e.val().toLowerCase(), h.add(f).addClass(i.noresult), h.each(function () {
                    var b = a(this);
                    a(l, b).text().toLowerCase().indexOf(d) > -1 && b.add(b.prevAll("." + i.label).first()).removeClass(i.noresult)
                }), a(a("ul." + i.submenu, b).get().reverse()).each(function () {
                    var b = a(this), c = b.data(k.parent),
                        e = (b.attr("id"), b.find("li").not("." + i.subtitle).not("." + i.label).not("." + i.noresult));
                    e.length ? c && c.removeClass(i.noresult).removeClass(i.nosubresult).prevAll("." + i.label).first().removeClass(i.noresult) : (b.trigger(j.close), c && c.addClass(i.nosubresult))
                }), b[h.not("." + i.noresult).length ? "removeClass" : "addClass"](i.noresults), g.trigger(j.count)
            })
        }
    }, a.fn.mmenu.search.defaults = {
        add: !1,
        search: !0,
        showLinksOnly: !0,
        placeholder: "Search",
        noResults: "No results found."
    }, a.fn.mmenu.counters = function (b, c, d) {
        "boolean" == typeof c && (c = {
            add: c,
            count: c
        }), "object" != typeof c && (c = {}), c = a.extend(!0, {}, a.fn.mmenu.counters.defaults, c), a("em." + d.counterClass, b).removeClass(d.counterClass).addClass(i.counter), c.add && a("." + i.submenu, b).each(function () {
            var c = a(this), d = c.attr("id");
            if (d && d.length) {
                var e = a('<em class="' + i.counter + '" />'), f = a("a." + i.subopen, b).filter('[href="#' + d + '"]');
                f.parent().find("em." + i.counter).length || f.before(e)
            }
        }), c.count && a("em." + i.counter, b).each(function () {
            var c = a(this), d = a("ul" + c.next().attr("href"), b);
            c.off(j.count).on(j.count, function (a) {
                a.preventDefault(), a.stopPropagation();
                var b = d.children().not("." + i.label).not("." + i.subtitle).not("." + i.noresult).not("." + i.noresults);
                c.html(b.length)
            })
        }).trigger(j.count)
    }, a.fn.mmenu.counters.defaults = {add: !1, count: !0}, a.fn.mmenu.dragOpen = function (b, d, f) {
        if (!a.fn.hammer) return !1;
        if ("boolean" == typeof d && (d = {open: d}), "object" != typeof d && (d = {}), d = a.extend(!0, {}, a.fn.mmenu.dragOpen.defaults, d), d.open) {
            var g = !1, h = !1, l = 0, m = 0, n = b.data(k.options);
            switch (n.position) {
                case"left":
                    var o = {
                        events: j.dragleft + " " + j.dragright,
                        open_dir: "right",
                        close_dir: "left",
                        delta: "deltaX",
                        negative: !1
                    };
                    break;
                case"right":
                    var o = {
                        events: j.dragleft + " " + j.dragright,
                        open_dir: "left",
                        close_dir: "right",
                        delta: "deltaX",
                        negative: !0
                    };
                    break;
                case"top":
                    var o = {
                        events: j.dragup + " " + j.dragdown,
                        open_dir: "down",
                        close_dir: "up",
                        delta: "deltaY",
                        negative: !1
                    };
                    break;
                case"bottom":
                    var o = {
                        events: j.dragup + " " + j.dragdown,
                        open_dir: "up",
                        close_dir: "down",
                        delta: "deltaY",
                        negative: !0
                    }
            }
            e.hammer().on(o.events + " " + j.dragend, function (a) {
                a.gesture.preventDefault(), a.stopPropagation()
            }).on(o.events, function (j) {
                var p = o.negative ? -j.gesture[o.delta] : j.gesture[o.delta];
                if (h = p > l ? o.open_dir : o.close_dir, l = p, l > d.threshold) {
                    if (!g) {
                        if (c.hasClass(i.opened)) return;
                        switch (g = !0, b.data(k.opened, !0), w(b, n, f), c.addClass(i.dragging), n.position) {
                            case"left":
                            case"right":
                                m = E(a(window).width(), 0, f.dragOpen.pageMaxDistance) - f.dragOpen.pageMinVisible;
                                break;
                            default:
                                m = a(window).height() - f.dragOpen.pageMinVisible
                        }
                    }
                    g && e.css("margin-" + n.position, E(l, 0, m))
                }
            }).on(j.dragend, function () {
                g && (g = !1, e.css("margin-" + n.position, ""), c.removeClass(i.dragging), h == o.open_dir ? x(b, n, f) : (b.data(k.opened, !1), y(b, n, f)))
            })
        }
    }, a.fn.mmenu.dragOpen.defaults = {
        open: !1,
        threshold: 50
    }, a.fn.mmenu.useOverflowScrollingFallback = function (a) {
        return c ? ("boolean" == typeof a && c[a ? "addClass" : "removeClass"](i.nooverflowscrolling), c.hasClass(i.nooverflowscrolling)) : (m = a, a)
    }, a.fn.mmenu.support = {
        touch: function () {
            return "ontouchstart" in window.document
        }(), overflowscrolling: function () {
            return "WebkitOverflowScrolling" in window.document.documentElement.style
        }(), oldAndroid: function () {
            var a = navigator.userAgent;
            return a.indexOf("Android") >= 0 ? 2.4 > parseFloat(a.slice(a.indexOf("Android") + 8)) : !1
        }(), transition: function () {
            return "transition" in document.createElement("div").style
        }()
    }, a.fn.mmenu.debug = function (a) {
        "undefined" != typeof console && "undefined" != typeof console.log && console.log("MMENU: " + a)
    }, a.fn.mmenu.deprecated = function (a, b) {
        "undefined" != typeof console && "undefined" != typeof console.warn && console.warn("MMENU: " + a + " is deprecated,use " + b + " instead.")
    };
    var l = 0, m = a.fn.mmenu.support.touch && !a.fn.mmenu.support.overflowscrolling
}(jQuery);